import React from 'react'
import {Avatar} from "@material-ui/core";
import "./Story.css"


function Story() {
    return (
        <div className="storyy">
            <div className="storyReel">
            <Avatar className="story__avatar" src="pic1.png"/>
            <h4>Taran</h4>
        </div>
            
            <div className="storyReel">
            <Avatar className="story__avatar" src="pic2.png"/>
            <h4>Adam</h4>
             </div>

            <div className="storyReel">
            <Avatar className="story__avatar" src="pic3.png"/>
            <h4>Chris</h4>
              </div>

            <div className="storyReel">
            <Avatar className="story__avatar" src="pic4.png"/>
            <h4>Bob</h4>
             </div>

            <div className="storyReel">
            <Avatar className="story__avatar" src="pic5.png"/>
            <h4>Jonny</h4>
             </div>

             <div className="storyReel">
            <Avatar className="story__avatar" src="pic1.png"/>
            <h4>Chandler</h4>
             </div>

            

        </div>
    )
}

export default Story
